import { SignalrService } from './shared/services/signalr.service';
import { Component, OnInit } from '@angular/core';
import { Alert } from './shared/models/alert';
import { UiStateStore } from './shared/store/ui-state-store.service';
import { AppStore } from './shared/store/lookup-store.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  alert: Alert;
  staticAlertOpened: boolean;
  title = 'angular-cient';

  constructor(private uiState: UiStateStore,
    private signalR: SignalrService,
    private lookupStore: AppStore,
    private spinner: NgxSpinnerService) {
    this.staticAlertOpened = false;
    this.lookupStore.isLookupDataLoaded$.subscribe(resp => {
      if(resp){
        this.spinner.hide();
      }
    })
  }

  async ngOnInit() {
    await this.signalR.connect();

    this.uiState.error.subscribe(error => {
      if (!error) {
        return;
      }

      this.alert = Alert.error(error);
      this.staticAlertOpened = true;
      setTimeout(() => this.staticAlertOpened = false, 5000);
    });

    this.uiState.success.subscribe(message => {
      if (!message) {
        return;
      }

      this.alert = Alert.success(message);
      this.staticAlertOpened = true;
      setTimeout(() => this.staticAlertOpened = false, 5000);
    });

  }

  public closeAlert(): void {
    this.staticAlertOpened = false;
  }

}
